module.exports = __webpack_public_path__ + "img/createBusinessImg.0e413132.png";